import type { RoleConfig } from '../types.js';

export const capo: RoleConfig = {
  id: 'capo',
  faction: 'mafia',
  title: { ru: 'Капо', uk: 'Капо' },
  latin: 'CAPO',
  number: '39',
  accent: '#caa86a',
  sub: '#7a5a2a',
  ability: {
    ru: 'Дважды за игру надевает бронежилет — этой ночью не умирает.',
    uk: 'Двічі за гру одягає бронежилет — цієї ночі не вмирає.',
  },
  abilities: [
    {
      key: 'vest',
      phase: 'night',
      cadence: 'every-night',
      shape: 'targetless',
      targetless: true,
      charges: 2,
    },
  ],
  reveals: { factions: ['mafia'] },
  victory: { type: 'mafia' },
  seniority: 60,
};
